import { CommonModule, DOCUMENT } from '@angular/common';
import { ChangeDetectorRef, Component, EventEmitter, Inject, Input, NgModule, OnChanges, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { LinkModule } from '@app/directives/link.directive';

@Component({
  selector: 'app-gallery',
  templateUrl: './gallery.component.html',
  styleUrls: ['./gallery.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class GalleryComponent implements OnInit, OnChanges {

  @Input() images: Array<string>;
  @Input() isSelectable = false;
  @Input() maxAmountSelectable = 1;
  @Input() clearSelections = false;

  @Output() imageChange = new EventEmitter<Array<string>>();
  @Output() imageEnter = new EventEmitter<string>();
  @Output() imageLeave = new EventEmitter<string>();

  fetchedAmountOfImages: number;
  // MUST be x, where x * lowest Bootstrap breakpoint in HTML = 12
  // This is to make sure that the images are always shown in a uniform grid
  amountToDisplay = 4;
  amountToDisplayCurrently: number;
  amountToIncrement: number;

  currentImagesShowing: Array<string>;
  currentlySelectedImages: Array<string>;

  objectFitFallback = false;

  constructor(@Inject(DOCUMENT) private document: Document,
              private cdRef: ChangeDetectorRef) { }

  ngOnInit() {
    this.currentlySelectedImages = new Array<string>();

    this.fetchedAmountOfImages = this.images.length;
    this.amountToDisplayCurrently = this.amountToDisplay;
    this.amountToIncrement = this.amountToDisplay;
    this.currentImagesShowing = this.images.slice(0, this.amountToDisplayCurrently);

    if ('objectFit' in this.document.documentElement.style === false) {
      this.objectFitFallback = true;
    }
  }

  isImageSelected(url: string): boolean {
    if (this.clearSelections) {
      return false;
    }
    return this.currentlySelectedImages.some(image => image === url);
  }

  hoverImage(url: string) {
    this.imageEnter.emit(url);
  }

  dehoverImage(url: string) {
    this.imageLeave.emit(url);
  }

  selectImage(url: string) {
    // If selections isn't enabled and we end up in here, always exit early
    if (!this.isSelectable) {
      return;
    }

    if (this.isImageSelected(url)) {
      this.currentlySelectedImages = this.currentlySelectedImages.filter(image => image !== url);
    } else if (this.currentlySelectedImages.length < this.maxAmountSelectable) {
      this.currentlySelectedImages.push(url);
    } else if (this.currentlySelectedImages.length >= this.maxAmountSelectable) {
      this.currentlySelectedImages.shift();
      this.currentlySelectedImages.push(url);
    }
    this.emitSelectedImages();
    this.cdRef.detectChanges();
  }

  emitSelectedImages() {
    const images = Array.from(this.currentlySelectedImages);
    this.imageChange.emit(images);
  }

  setFallBackStyle(imageItem: HTMLImageElement) {
    if (this.objectFitFallback) {
      imageItem.parentElement.style.backgroundImage = `url(${imageItem.src})`;
      imageItem.parentElement.style.backgroundSize = `cover`;
      imageItem.parentElement.style.backgroundPosition = `center`;
      return {
        'display': `none`
      };
    }
  }

  showMoreImages() {
    this.amountToDisplayCurrently += this.amountToIncrement;
    this.currentImagesShowing = this.images.slice(0, this.amountToDisplayCurrently);
  }

  showLessImages() {
    this.amountToDisplayCurrently = this.amountToDisplay;
    this.currentImagesShowing = this.images.slice(0, this.amountToDisplayCurrently);
  }

  ngOnChanges() {
    if (this.clearSelections) {
      this.currentlySelectedImages = new Array<string>();
    }
  }

}
@NgModule({
  declarations: [GalleryComponent],
  exports: [GalleryComponent],
  imports: [
    CommonModule,
    LinkModule,
    MatCheckboxModule,
    MatButtonModule
  ]
})
export class GalleryModule { }
